import React from 'react';
import {Page} from '../../types';
import {Link} from '../../components';

type MenuItem = {
  title: string;
  link: Page;
};

export const DropdownMenu = ({
  menuItems,
  pastTop,
}: {
  menuItems: MenuItem[];
  pastTop: boolean;
}) => {
  return (
    <div className="absolute left-0 top-full w-max pt-2">
      <ul
        className={`list-none min-w-[10rem] rounded-2xl shadow-sm py-2 z-50 ${
          pastTop ? 'bg-background' : 'bg-background/70 backdrop-blur-md'
        }`}>
        {menuItems.map((item, i) => {
          return (
            <li key={i} className="text-smallbodymob">
              <Link
                className="block px-4 py-2 text-black hover:underline"
                linkTo={item.link}>
                {item.title}
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
